export default Object.freeze({
  TEXT_INPUT_TYPE_ID: 'SustaLV_002',
  INTEGER_INPUT_TYPE_ID: 'SustaLV_003',
  DECIMAL_INPUT_TYPE_ID: 'SustaLV_004',
  BOOLEAN_INPUT_TYPE_ID: 'SustaLV_005',
  ONE_MB_IN_BYTES: 1048576,
  WILDCARD_FILE_EXTENSION: '.*',
  ATTACHMENT_RELATION_ID: 'bms_FK_SustaRl_010_ID',
})
